import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO description="Go言語を実務で利用するために理解しておくべきことをまとめたWEBコンテンツです" title="実務のGo" />
    <section class="hero is-primary is-medium">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-1">実務のGo</h1>
          <h2 class="subtitle is-4">コンテナ時代のプログラミング言語</h2>
          <p>最終更新 — 2020/09/17</p>
          <p>毎週月曜日と木曜日に更新しています</p>
          <p><Link className="button is-link large" to="/docs">ドキュメント</Link></p>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-1"></div>
          <div class="column is-8">
          <div class="content">
            <h2 class="title">実務のGoとは</h2>
            <p>実務のGoは、Go言語を実務で利用するために理解しておくべきことをまとめたWEBコンテンツです。</p>
          </div>
          <div class="content">
            <h2 class="title">対象者</h2>
            <p>実務のGoは、以下のような人を対象にしています。</p>
            <ul>
              <li>Goをプロジェクトで使おうと考えている</li>
              <li>他の言語の開発経験はあるが、Goの開発経験はない</li>
              <li>Goで他の言語にある機能の実装方法がわからない</li>
            </ul>
          </div>
          <div class="content">
            <h2 class="title">最近の記事</h2>
            <ul>
              <li><Link to="/doc/library/update-from-gormv1-to-gormv2">gorm version1からversion2にアップデートする</Link></li>
            </ul>
          </div>
          <div class="content">
            <h2 class="title">おすすめ利用方法</h2>
            <p>Goの公式サイト等と併用しながらご利用ください。また、このサイトのコンテンツは、Goの開発に必要な他の開発技術も扱っています。</p>
          </div>
          </div>
          <div class="column is-1"></div>
        </div>
      </div>
    </section>
  </Layout>
)

export default IndexPage
